<template>
    <svg fill="none" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 8.5L5 12.5L15 1" stroke="currentColor" stroke-linecap="round" stroke-width="2" />
    </svg>
</template>
